
  import * as Sentry from '@sentry/browser';

  Sentry.init({ dsn: 'https://8c7f27fdf6b04ea8af2152a3b3a93c02@o589494.ingest.sentry.io/5739583' });

  window.Sentry = Sentry;

